function Contact() {
    return (
      <>
        <h1>Контакты</h1>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus id quidem, necessitatibus esse repellendus et, quam officiis libero maiores adipisci natus sed iusto! Nemo minus porro, quam fugit blanditiis voluptates!
      </>
    );
  }
  
  export default Contact;